import React from 'react';
import { MdCampaign } from 'react-icons/md';
import { PaginaDeportes } from '../_shared';
import TablaConvocatorias from './TablaConvocatorias';

const Convocatorias: React.FC = () => (
  <PaginaDeportes
    icon={MdCampaign}
    titulo="Convocatorias Deportivas"
    subtitulo="Publicación de convocatorias al portal y gestión de inscripciones"
  >
    <TablaConvocatorias />
  </PaginaDeportes>
);

export default Convocatorias;
